import { render } from "./ApprovalsListCardSection.vue?vue&type=template&id=34818714"
import script from "./ApprovalsListCardSection.vue?vue&type=script&lang=js"
export * from "./ApprovalsListCardSection.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__